export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_FUNCTIONALITIES_SUCCESS = 'FETCH_FUNCTIONALITIES_SUCCESS';
export const FETCH_FUNCTIONALITY_SUCCESS = 'FETCH_FUNCTIONALITY_SUCCESS';
export const SELECT_FUNCTIONALITY = 'SELECT_FUNCTIONALITY';
export const HIDE_LOADER = 'HIDE_LOADER';
